// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 21H1V3H23V21ZM6.5 8V10H9V14H5V16H9.59961C9.84165 16 10.1112 15.9492 10.3555 15.8184C10.558 15.7097 10.9998 15.3914 11 14.7861V8H6.5ZM13 16H15V13.2139H17.5C18.1782 13.2139 18.9998 12.7139 19 11.7861V9.42871C19 8.50067 18.1783 8 17.5 8H13V16ZM17 11.2139H15V10H17V11.2139Z"}}]};

const JapaneseRectangleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'japanese-rectangle-filled',
    ref,
    icon: element,
  },
));

JapaneseRectangleFilledIcon.displayName = 'JapaneseRectangleFilledIcon';

export default JapaneseRectangleFilledIcon;
